export const Breakpoints = {
    laptopSmall: `@media screen and (max-width: 1200px)`,
    tablet: `@media screen and (max-width: 800px)`,
    mobile: `@media screen and (max-width: 500px)`,
}